import React, {Component} from 'react';
import classNames from 'classnames';
import MakeHash from 'make-hash';
import Button from 'components/button/button';
import GridRow from 'components/grid/grid-row';
import GridCol from 'components/grid/grid-col';
import Text from 'components/text/text';
import RiderProfile from './_rider-profile';

export default class RiderProfiles extends Component {
  constructor() {
    super();

    this.title = `Rider Profiles`;
    this.data = {
      'profiles': [
        {
          'name': 'User Road',
          'type': 'Road',
          'position': 'Low',
          'frequency': '6 times per week',
          'duration': '0-30 minutes'
        },
        {
          'name': 'User Mountain',
          'type': 'Mountain',
          'position': 'Mid',
          'frequency': '1-3 times per week',
          'duration': '0-30 minutes'
        }
      ]
    }

    this.setUpHandlers();
  }

  /**
   * Binds any handlers to the correct context
   *
   * @method  setUpHandlers
   */
  setUpHandlers() {
    this.createProfile = this.createProfile.bind(this);
  }

  createProfile() {
    alert('create profile -- future placeholder');
  }

  render() {
    return (
      <section className="tier mix-tier_bordered">
        <div className="set">
          <div className="set-hd">
            <Text
              align="center"
              className="mix-txt_alignCenter"
              type="xl"
              tag="h2"
              weight="light"
            >
              {this.title}
            </Text>
          </div>
          <div className="set-bd set-bd_detached mix-set-bd_alignCenter">
            <Button
              className="mix-btn_mobile"
              theme="dark"
              onClick={this.createProfile}
            >
              Create Rider Profile
            </Button>
          </div>
          <div className="set-bd set-bd_super">
            <GridRow>
              {this.data.profiles.map((profile, i) => {
                return (
                  <GridCol
                    className="cell_separatedSm cell_separatedMd cell_separatedMdLg"
                    desktop="6"
                    key={MakeHash(`rider-profile-${i}`)}
                   >
                    <RiderProfile
                      index={i}
                      data={profile}
                    />
                  </GridCol>
                );
              })}
            </GridRow>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/client/pages/profile/_rider-profiles.jsx